import { EmployeeDocument } from '../Employees/queryBuilder';
import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import {
  EquipmentDeficiencyDocument,
  equipmentDeficiencyPullQueryBuilder,
  equipmentDeficiencyPushQueryBuilder,
} from './queryBuilder';

export function equipmentDeficiencyFamilyMember(
  configBuilder: ConfigBuilder,
  employees: FamilyMember<EmployeeDocument>,
  equipment: FamilyMember<EquipmentDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<EquipmentDeficiencyDocument> {
  const syncConfig = configBuilder<EquipmentDeficiencyDocument>(
    RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, equipmentDeficiencyPullQueryBuilder);
  push(syncConfig, equipmentDeficiencyPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.EQUIPMENT_DEFICIENCY, replicationState, [
    employees,
    equipment,
    sites,
  ]);
}
